<template> 
  <div id="app"> 
    <v-app> 
      <v-main>
        <router-view/>
      </v-main>
    </v-app> 
  </div> 
</template>
<script> 
export default { 
  name: "App", 
  data() { 
    return {}; 
  } 
}; 
</script>
